import type { ActionView } from '../../../shared/views'

/** Файл загрузки до 30 МиБ (`CatalogPhotoLimits`). */
export const COMMON_PHOTO_MAX_BYTES = 30 * 1024 * 1024

/**
 * Этапы загрузки. `review` (RP-FB73) — сервер вернул вырез без фона и предложенную рамку обрезки, ждём человека: «Принять» с рамкой или «Отмена».
 * Пока фото не принято, на сервере ничего не сохранено.
 */
export type PhotoUploadPhase = 'preparing' | 'sending' | 'waiting' | 'review' | 'failed'

/** Рамка обрезки в пикселях выреза (`CatalogPhotoCropBoxDto`): левая и верхняя границы входят, правая и нижняя — нет. */
export interface CropBox {
  left: number
  top: number
  right: number
  bottom: number
}

/** Ответ подготовки загрузки (`CatalogPhotoPreparationDto`, RP-FB73): вырез без фона БЕЗ обрезки и рамка, которую предложила автообрезка. */
export interface PhotoPreparation {
  /** JPEG выреза в base64. */
  cutoutBase64: string
  contentType: string
  width: number
  height: number
  proposedBox: CropBox
  /** `applied` — предмет найден; `skipped-*` — не найден, рамка стоит на весь кадр. */
  cropStatus: string
  /** Пояснение словами, когда предмет не найден; `null` — найден. */
  cropStatusText: string | null
  /** Отступ от рамки до края итогового квадрата, px. */
  margin: number
  /** Предел длинной стороны итогового кадра, px. */
  maxSide: number
}

/** Проверка обрезки человеком: вырез для показа (адрес объекта на устройстве), размеры и предложенная рамка. */
export interface PhotoCropReviewVm {
  cutoutUrl: string
  width: number
  height: number
  proposedBox: CropBox
  /** Почему рамка стоит на весь кадр (предмет не найден); `null` — предмет найден. */
  statusText: string | null
  margin: number
  maxSide: number
}

/** Идущая или упавшая загрузка: превью снимка, слова этапа, реальные байты. Долю не выдумываем: нет данных — нет доли. */
export interface PhotoUploadVm {
  fileName: string
  previewUrl: string | null
  phase: PhotoUploadPhase
  /** Только на этапе `review`: что показать человеку для проверки обрезки. */
  review?: PhotoCropReviewVm | undefined
  /** Слова этапа: «Готовлю снимок», «Отправляю», «Жду ответ сервера», «Не загружено». */
  stage: string
  loaded: number
  total: number | null
  fraction?: number | undefined
  cancelable: boolean
  /** Отказ сервера дословно (с кодом и номером запроса) — не пропадает, пока человек не закроет. */
  error: ActionView['error']
}
